import React, { useState, useEffect } from 'react';
import Navbar from '../layout/Navbar';
import Footer from '../layout/Fotter';
import WoodenTils from '../../assets/wooden-tils.webp';
// Placeholder images for High Gloss tiles (replace with actual high gloss tile image assets)


const HighGloss = () => {
  // State for modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [isImageLoading, setIsImageLoading] = useState(true);

  // State for filters
  const [selectedSize, setSelectedSize] = useState("80x80mm"); // Default size
  const [selectedFinish, setSelectedFinish] = useState(null);

  // Available Finishes
  const availableFinishes = [
    'BOOKMATCH', 'CARVING', 'DC', 'GLOSSY 1',
    'GLOSSY 2', 'GLOSSY 3', 'GLOSSY ENDLESS', 'GLOSSY LIGHT & DARK',
    'MATT', 'MONOTONE', 'RAINBOW', 'STATUARIO',
    'TERRAZZO COLLECTION', 'WOOD'
  ];
  // Function to open modal with selected image
  const openModal = (image, title) => {
    setIsImageLoading(true);
    setSelectedImage({ src: image, title });
    setIsModalOpen(true);
  };

  // Function to close modal
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedImage(null);
    setIsImageLoading(true);
  };

  // Handle outside click to close modal
  const handleOutsideClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  // Handle keyboard accessibility and prevent body scroll
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        closeModal();
      }
    };
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
      window.addEventListener('keydown', handleKeyDown);
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isModalOpen]);

  // High Gloss tiles collection data with room scenes and individual tiles
  const glossCollections = [

  ];

  const glossCategory = {
    fullName: "Wooden Finish Tiles",
    description:
      "Premium wooden finish tiles offering a reflective, luxurious surface that enhances light and space in any interior.",
    features: ["Water Absorption < 0.5%", "Highly Reflective Surface", "Stain Resistant", "Low Maintenance"],
    sizes: ["80x80mm", "13x80mm", "60x60mm", "40x40mm"],
  };

  // Filter collections based on selected size and finish
  const filteredCollections = glossCollections.filter(collection => {
    // Logic: If a filter is selected, the item must match.
    if (selectedSize && collection.size !== selectedSize) return false;
    if (selectedFinish && collection.finish !== selectedFinish) return false;
    return true;
  });

  const showResults = true; // Always show even if empty, or handle empty state within map

  return (
    <div className="w-full overflow-hidden">
      {/* Navbar */}
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-[50vh] sm:h-[60vh] md:h-[70vh] lg:h-[80vh] bg-gradient-to-r from-gray-900 via-gray-800 to-orange-900">
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${WoodenTils})` }}
        ></div>
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <div className="relative z-10 h-full flex items-center justify-center">
          <div className="text-center text-white max-w-full sm:max-w-2xl md:max-w-3xl lg:max-w-4xl px-4 sm:px-6">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-orange-500 mb-4 sm:mb-6 drop-shadow-2xl">
              Wooden Collection
            </h1>
            <p className="text-base sm:text-lg md:text-xl lg:text-2xl font-light">
              {glossCategory.fullName}
            </p>
            <div className="mt-4 sm:mt-6 w-24 sm:w-28 lg:w-32 h-1 bg-orange-500 mx-auto"></div>
          </div>
        </div>
      </section>

      {/* Product Info Section */}
      <section className="py-8 sm:py-12 lg:py-16 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12 lg:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-3 sm:mb-4">
              Premium <span className="text-orange-600">Wooden Tiles</span>
            </h2>
            <p className="text-sm sm:text-base md:text-lg text-gray-600 max-w-2xl sm:max-w-3xl lg:max-w-4xl mx-auto mb-6 sm:mb-8 leading-relaxed">
              {glossCategory.description} Our wooden tiles combine advanced technology with a mirror-like finish to create stunning, reflective spaces.
            </p>
            {/* Features */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 max-w-5xl mx-auto">
              {glossCategory.features.map((feature, index) => (
                <div
                  key={index}
                  className="bg-gradient-to-br from-orange-50 to-orange-100 p-4 sm:p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300"
                >
                  <div className="bg-orange-600 text-white text-lg sm:text-xl md:text-2xl w-10 h-10 sm:w-12 sm:h-12 rounded-full flex items-center justify-center mx-auto mb-3 sm:mb-4">
                    ✓
                  </div>
                  <p className="text-gray-800 font-semibold text-sm sm:text-base md:text-lg">{feature}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* NEW FILTER SECTION */}
      <section className="py-8 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-1">
          <div className="bg-white rounded-[2rem] p-6 sm:p-8 md:p-12 shadow-xl border border-gray-100">
            <div className="flex flex-col lg:flex-row gap-8 lg:gap-16">

              {/* Size Selection */}
              <div className="lg:w-1/3">
                <h3 className="text-gray-800 text-xl sm:text-2xl font-medium mb-6">Choose By Size</h3>
                <div className="flex flex-col gap-4">
                  {glossCategory.sizes.map((size) => (
                    <button
                      key={size}
                      onClick={() => setSelectedSize(selectedSize === size ? null : size)}
                      className={`
                        w-full py-4 px-6 rounded-xl text-lg font-bold transition-all duration-300 border
                        ${selectedSize === size
                          ? 'bg-orange-600 text-white border-orange-600 shadow-lg scale-105'
                          : 'bg-white border-gray-200 text-gray-600 hover:border-orange-200 hover:bg-orange-50'}
                      `}
                    >
                      {size.toUpperCase()}
                    </button>
                  ))}
                </div>
              </div>

              {/* Vertical Divider (Visible on Large Screens) */}
              <div className="hidden lg:block w-px bg-gray-200 my-2"></div>

              {/* Horizontal Divider (Visible on Small Screens) */}
              <div className="block lg:hidden h-px w-full bg-gray-200"></div>

              {/* Finish Selection */}
              <div className="lg:w-2/3">
                <h3 className="text-gray-800 text-xl sm:text-2xl font-medium mb-6">Choose By Finish</h3>
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 sm:gap-4">
                  {availableFinishes.map((finish) => (
                    <button
                      key={finish}
                      onClick={() => setSelectedFinish(selectedFinish === finish ? null : finish)}
                      className={`
                        py-3 px-2 sm:px-4 rounded-xl text-xs sm:text-sm font-bold transition-all duration-300 h-16 sm:h-20 flex items-center justify-center text-center border
                        ${selectedFinish === finish
                          ? 'bg-orange-600 text-white border-orange-600 shadow-lg scale-105'
                          : 'bg-white border-gray-200 text-gray-600 hover:border-orange-200 hover:bg-orange-50'}
                      `}
                    >
                      {finish}
                    </button>
                  ))}
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* Results Section */}
      {showResults && (
        <section className="py-8 sm:py-12 bg-gray-50 min-h-[500px]">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between mb-8 sm:mb-12">
              <div className="text-left w-full">
                <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-800">
                  <span className="text-orange-600">Selected</span> Collections
                </h2>
                <div className="mt-2 text-gray-600">
                  Showing results for:
                  {selectedSize && <span className="ml-2 px-3 py-1 bg-orange-100 text-orange-800 rounded-full text-sm font-medium">{selectedSize}</span>}
                  {selectedFinish && <span className="ml-2 px-3 py-1 bg-gray-200 text-gray-800 rounded-full text-sm font-medium">{selectedFinish}</span>}
                </div>
              </div>
            </div>

            <div className="space-y-8 sm:space-y-10 lg:space-y-12">
              {filteredCollections.length > 0 ? (
                filteredCollections.map((collection) => (
                  <div key={collection.id} className="bg-white rounded-xl shadow-2xl overflow-hidden animate-fade-in-up">
                    {/* Collection Header */}
                    <div className="bg-gradient-to-r from-orange-600 to-orange-700 text-white p-4 sm:p-6">
                      <h3 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold text-center">{collection.name}</h3>
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-4 gap-4 sm:gap-6 p-4 sm:p-6">
                      {/* Left Side - Room Scene */}
                      <div className="lg:col-span-1 relative group">
                        <div className="relative w-full aspect-square overflow-hidden rounded-2xl">
                          <img
                            src={collection.roomImage}
                            alt={`${collection.name} room scene`}
                            className="w-full h-full object-cover rounded-2xl group-hover:scale-105 transition-transform duration-500"
                            loading="lazy"
                          />
                          <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl"></div>
                          <div className="absolute bottom-3 sm:bottom-4 left-3 sm:left-4 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                            <h4 className="text-sm sm:text-base md:text-lg font-bold mb-1">{collection.name}</h4>
                            <p className="text-xs bg-black/50 px-2 py-1 rounded-full">Room Application</p>
                          </div>
                          <button
                            onClick={() => openModal(collection.roomImage, `${collection.name} - Room Scene`)}
                            className="absolute top-2 sm:top-3 right-2 sm:right-3 bg-white/90 text-gray-800 p-1.5 sm:p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 hover:bg-white shadow-md"
                          >
                            🔍
                          </button>
                        </div>
                      </div>

                      {/* Right Side - Tiles Images */}
                      <div className="lg:col-span-3">
                        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4">
                          {collection.tileImages.slice(0, 4).map((tileImage, tileIndex) => (
                            <div key={tileIndex} className="relative group/tile cursor-pointer">
                              <div className="aspect-square relative overflow-hidden rounded-2xl shadow-md">
                                <img
                                  src={tileImage}
                                  alt={`${collection.name} tile design ${tileIndex + 1}`}
                                  className="w-full h-full object-cover group-hover/tile:scale-110 transition-transform duration-300 rounded-2xl"
                                  onClick={() => openModal(tileImage, `${collection.name} - Design ${tileIndex + 1}`)}
                                  loading="lazy"
                                />
                                <div className="absolute inset-0 bg-black/0 group-hover/tile:bg-black/20 transition-colors duration-300 rounded-2xl"></div>
                                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover/tile:opacity-100 transition-opacity duration-300">
                                  <div className="bg-white/90 text-gray-800 p-1.5 sm:p-2 rounded-full shadow-md">
                                    🔍
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                        {/* Collection Details */}
                        <div className="mt-4 sm:mt-6">
                          <p className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4 leading-relaxed">{collection.description}</p>
                          <div className="flex flex-wrap gap-2 sm:gap-3 mb-3 sm:mb-4">
                            <span className="bg-orange-100 text-orange-800 text-xs sm:text-sm px-2 sm:px-3 py-1 rounded-full">
                              Size: {collection.size}
                            </span>
                            <span className="bg-orange-100 text-orange-800 text-xs sm:text-sm px-2 sm:px-3 py-1 rounded-full">
                              Finish: {collection.finish}
                            </span>
                          </div>
                          <ul className="text-sm sm:text-base text-gray-600 space-y-1 sm:space-y-2">
                            {collection.features.map((feature, index) => (
                              <li key={index} className="flex items-center">
                                <span className="text-orange-600 mr-2">✓</span> {feature}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="text-center py-10 text-gray-500">
                  <p className="text-xl">No collections found matching your selection.</p>
                  <p className="mt-2 text-sm">Try adjusting your size or finish filters.</p>
                </div>
              )}
            </div>
          </div>
        </section>
      )}

      {/* Available Sizes Section */}
      <section className="py-8 sm:py-12 lg:py-16 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-3 sm:mb-4">
              Available <span className="text-orange-600">Sizes</span>
            </h2>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4 lg:gap-6 max-w-2xl sm:max-w-3xl lg:max-w-4xl mx-auto">
              {glossCategory.sizes.map((size, index) => (
                <div
                  key={index}
                  className="bg-gradient-to-br from-orange-100 to-orange-200 text-orange-800 font-bold py-3 sm:py-4 px-4 sm:px-6 rounded-xl text-center shadow-lg hover:shadow-xl transition-shadow duration-300 transform hover:-translate-y-1"
                >
                  <div className="text-lg sm:text-xl md:text-2xl mb-1 sm:mb-2">📏</div>
                  <div className="text-sm sm:text-base md:text-lg">{size}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Technical Specifications */}
      <section className="py-8 sm:py-12 lg:py-16 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-3 sm:mb reinforcement-learning-4">
              Technical <span className="text-orange-600">Specifications</span>
            </h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 max-w-2xl sm:max-w-4xl lg:max-w-6xl mx-auto">
            {[
              { icon: "💧", title: "Water Absorption", desc: "Less than 0.5% as per IS 15622" },
              { icon: "💪", title: "Breaking Strength", desc: "Minimum 1800N as per IS 15622" },
              { icon: "✨", title: "Reflective Surface", desc: "Wooden finish for enhanced light reflection" },
            ].map((spec, index) => (
              <div key={index} className="bg-white p-4 sm:p-6 rounded-xl shadow-lg">
                <div className="text-orange-600 text-2xl sm:text-3xl md:text-4xl mb-3 sm:mb-4 text-center">{spec.icon}</div>
                <h3 className="text-base sm:text-lg md:text-xl font-bold text-gray-800 mb-2 text-center">{spec.title}</h3>
                <p className="text-sm sm:text-base text-gray-600 text-center">{spec.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-8 sm:py-12 lg:py-16 bg-gradient-to-r from-orange-600 to-orange-700">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3 sm:mb-4">
            Transform Your Space Today
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-orange-100 mb-6 sm:mb-8 max-w-2xl sm:max-w-3xl mx-auto leading-relaxed">
            Contact our design experts to find the perfect wooden finish tiles for your project. Get personalized recommendations and professional installation support.
          </p>
        </div>
      </section>

      {/* Modal for Image Zoom */}
      {isModalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 p-2 sm:p-4"
          onClick={handleOutsideClick}
        >
          <div className="relative w-full max-w-[95vw] sm:max-w-4xl md:max-w-5xl lg:max-w-6xl max-h-[90vh] mx-auto">
            {isImageLoading && (
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-12 sm:w-14 lg:w-16 h-12 sm:h-14 lg:h-16 border-4 border-orange-600 border-t-transparent rounded-full animate-spin"></div>
              </div>
            )}
            <img
              src={selectedImage.src}
              alt={`Zoomed view of ${selectedImage.title}`}
              className="w-full h-auto max-h-[90vh] object-contain rounded-lg shadow-2xl"
              onLoad={() => setIsImageLoading(false)}
            />
            <button
              onClick={closeModal}
              className="absolute top-2 sm:top-3 right-2 sm:right-3 bg-white text-black rounded-full p-2 sm:p-3 hover:bg-gray-200 transition-all duration-300 text-base sm:text-lg lg:text-xl font-bold shadow-lg"
            >
              ✕
            </button>
            {selectedImage && !isImageLoading && (
              <div className="absolute bottom-2 sm:bottom-3 left-2 sm:left-4 bg-black/70 text-white px-3 sm:px-4 py-1 sm:py-2 rounded-lg">
                <h3 className="text-sm sm:text-base md:text-lg font-bold">{selectedImage.title}</h3>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default HighGloss;